(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ml-mobile-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ml-mobile-menu')) {
    customElements.define('ml-mobile-menu', class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('change', this.submitLocalization);
        this.addEventListener('click', this.closeForFaq);
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', this.connectFaq, { once: true });
        } else {
          this.faqFrame = requestAnimationFrame(this.connectFaq);
        }
      }
      disconnectedCallback() {
        this.removeEventListener('change', this.submitLocalization);
        this.removeEventListener('click', this.closeForFaq);
        document.removeEventListener('DOMContentLoaded', this.connectFaq);
        cancelAnimationFrame(this.faqFrame);
      }
      connectFaq = () => {
        const faq = document.querySelector('ml-faq-pills');
        if (!faq) return;
        if (!faq.id) faq.id = 'ml-menu-faq';
        const link = this.querySelector('[data-menu-faq]');
        if (link) link.setAttribute('href', '#' + faq.id);
        if (location.hash === '#' + faq.id) faq.scrollIntoView();
      };
      closeForFaq = (event) => {
        const link = event.target.closest('[data-menu-faq]');
        if (link) this.connectFaq();
        if (link?.getAttribute('href')?.startsWith('#')) this.closest('header-drawer')?.close();
      };
      submitLocalization(event) {
        if (event.target instanceof HTMLSelectElement && event.target.matches('[data-localization-select]')) {
          if (event.target.name === 'country_code' && event.target.value === 'CH') {
            window.location.assign('https://matchaland.ch/');
            return;
          }
          event.target.form?.requestSubmit();
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
